module.exports = __webpack_public_path__ + "static/media/logo-mixabl-grayscale.b036ecbb.svg";